import { useEffect, useState } from "react";

const useIsClient = () => {
  const [client, setClient] = useState(false);

  useEffect(() => {
    setClient(true);
  }, []);
  return client;
};

export default useIsClient;
